/* unplugin-vue-components disabled */import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "box-name"
};
const _hoisted_2 = {
  key: 1,
  class: "box-name"
};
const _hoisted_3 = {
  key: 2,
  class: "zimu-name"
};
const _hoisted_4 = {
  style: {
    "width": "100%",
    "height": "100%"
  },
  class: "map_video_card"
};
const _hoisted_5 = {
  class: "textTwos"
};
import VideoCard from "@/components/Card/VideoCard/index.vue";
import TextCard from "@/components/Card/TextCard/index.vue";
import screenfull from "screenfull";
import * as turf from '@turf/turf';
import * as echarts from 'echarts';
import usePermissionStore from "@/store/modules/permission";
export default {
  __name: 'tmap',
  props: {
    mapVideo: {
      type: Object
    },
    spilt: {
      type: Number
    },
    oneName: {
      type: String
    },
    showSubtitle: {
      type: Boolean,
      default: true
    },
    showSwitch: {
      type: Boolean,
      default: true
    },
    // 是否显示提示
    isTasking: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const zimuDiv = reactive({
      uid: 1,
      longitude: 108,
      latitude: 38,
      height: 1,
      headingAngle: 0,
      speed: 0
    });
    const permissionStore = usePermissionStore();
    const {
      proxy
    } = getCurrentInstance();
    const pageData = inject("pageData");
    const setRealMessage = inject("setRealMessage");
    const props = __props;
    watch(() => props.mapVideo.controlelSize, newVal => {
      if (newVal) {
        controlelSize.value = props.mapVideo.controlelSize;
      }
    });
    const controlelSize = ref("small");
    const fullscreen = ref(false);
    const zimu = ref(false);
    const zimuSwitch = ref(true);
    function onMapVideoCardSwitchChange() {
      zimuSwitch.value = !zimuSwitch.value;
      props.showSubtitle = !props.showSubtitle;
      if (props.showSubtitle) {
        nextTick(() => {
          initeCharts();
        });
      }
    }
    function onMapSwitchChange() {
      zimuSwitch.value = !zimuSwitch.value;
    }
    function onMapVideoCardFullScreenClick() {
      requestAnimationFrame(() => {
        const dom = document.getElementsByClassName("mapmincard")[0];
        if (screenfull.isEnabled) {
          if (fullscreen.value) {
            screenfull.exit();
            fullscreen.value = false;
          } else {
            screenfull.request(dom);
            fullscreen.value = true;
          }
        }
        setTimeout(() => {
          map.value.checkResize();
        }, 50);
      });
    }
    function onMapVideoCardUpdateView() {
      requestAnimationFrame(() => {
        const map = document.querySelector(".mapmincard");
        const chart = document.querySelector(".routerChatBg");
        if (map === null || chart === undefined || map === undefined || chart === null) return;
        const mapStyle = window.getComputedStyle(map);
        moveEbable.value = false;
        if (parseInt(mapStyle.height) > 900) {
          chart.style.transform = "scale(0.5)";
          moveEbable.value = true;
        } else if (parseInt(mapStyle.height) > 500) {
          chart.style.transform = "scale(0.4)";
          chart.style.left = "unset";
          chart.style.top = "10%";
          chart.style.right = "5%";
        } else {
          chart.style.transform = "scale(0.4)";
          chart.style.left = "unset";
          chart.style.top = "12%";
          chart.style.right = "5%";
        }
      });
    }
    const chatbox = ref();
    const moveEbable = ref(false);
    const dragx = el => {
      if (!moveEbable.value) {
        return false;
      }
      let oDiv = chatbox.value; //当前元素
      let disX = el.clientX - oDiv.offsetLeft;
      let disY = el.clientY - oDiv.offsetTop;
      document.onmousemove = function (e) {
        //通过事件委托，计算移动的距离
        let l = e.clientX - disX;
        let t = e.clientY - disY;
        if (l < 0) {
          //如果左侧的距离小于0，就让距离等于0.不能超出屏幕左侧。如果需要磁性吸附，把0改为100或者想要的数字即可
          l = 0;
        } else if (l > document.documentElement.clientWidth - oDiv.offsetWidth) {
          //如果左侧的距离>屏幕的宽度-元素的宽度。也就是说元素的右侧超出屏幕的右侧，就让元素的右侧在屏幕的右侧上
          l = document.documentElement.clientWidth - oDiv.offsetWidth;
        }
        if (t < 0) {
          //和左右距离同理
          t = 0;
        } else if (t > document.documentElement.clientHeight - oDiv.offsetHeight) {
          t = document.documentElement.clientHeight - oDiv.offsetHeight;
        }
        //移动当前元素
        oDiv.style.left = l + "px";
        oDiv.style.top = t + "px";
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      // 解决有些时候,在鼠标松开的时候,元素仍然可以拖动;
      document.ondragstart = function (ev) {
        ev.preventDefault();
      };
      document.ondragend = function (ev) {
        ev.preventDefault();
      };
      return false;
    };
    const initeCharts = () => {
      myChart = echarts.init(document.getElementById('myChart'));
      myChart.setOption(state.option);
      myChart1 = echarts.init(document.getElementById('myChart1'));
      myChart1.setOption(state.option1);
      myChart2 = echarts.init(document.getElementById('myChart2'));
      myChart2.setOption(state.option2);
      myChart3 = echarts.init(document.getElementById('myChart3'));
      myChart3.setOption(state.option3);
      myChart4 = echarts.init(document.getElementById('myChart4'));
      myChart4.setOption(state.option4);
    };
    let myChart, myChart1, myChart2, myChart3, myChart4;
    const state = reactive({
      currentposition: "--，-- ",
      currentflighttime: "--",
      currentdiatance: "--",
      option: {
        legend: {},
        tooltip: {},
        grid: {
          left: 60,
          right: 40
        },
        xAxis: {
          show: false
        },
        yAxis: {
          min: -6,
          max: 6,
          name: "空速 m/s",
          nameLocation: "end",
          boundaryGap: false,
          nameTextStyle: {
            color: "#FFFFFF",
            fontSize: 22,
            fontWeight: "bold",
            padding: [0, 0, 0, -15]
          },
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          minorTick: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            inside: false,
            length: 10,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          axisLabel: {
            margin: 14,
            fontSize: 22,
            fontWeight: "bold",
            showMinLabel: false,
            showMaxLabel: false
          }
        },
        series: [{
          type: "line",
          name: "空速",
          animation: false,
          markLine: {
            data: [{
              yAxis: 0
            }],
            lineStyle: {
              opacity: 0.8
            },
            label: {
              normal: {
                show: false
              }
            },
            symbol: ['image://https://block-design.oss-cn-shenzhen.aliyuncs.com/project-imgs/xingzhan/%E5%A4%9A%E8%BE%B9%E5%BD%A2%201.png', 'none'],
            symbolRotate: 90,
            symbolSize: [10, 30],
            symbolOffset: ["35%", 0]
          }
        }]
      },
      option1: {
        tooltip: {},
        grid: {
          left: 80,
          right: 0
        },
        xAxis: {
          show: false
        },
        yAxis: {
          min: -15,
          max: 15,
          name: "海拔|",
          nameLocation: "end",
          boundaryGap: false,
          nameTextStyle: {
            color: "#FFFFFF",
            fontSize: 22,
            fontWeight: "bold",
            padding: [0, 0, 0, -50]
          },
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          axisTick: {
            show: true,
            length: 10,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          splitLine: {
            show: false
          },
          minorTick: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          axisLabel: {
            margin: 14,
            fontSize: 22,
            fontWeight: "bold",
            showMinLabel: false,
            showMaxLabel: false,
            formatter: function (value) {
              let str = '';
              // num两种情况，为普通数字（1000以下不带逗号）或千分位数字，全部强转为string类型
              value = value.toString();
              // 将num按逗号分隔
              let arr = value.split(',');
              // for循环将去除逗号的部分拼起来
              for (let i = 0; i < arr.length; i++) {
                str += arr[i];
              }
              return str;
            }
          }
        },
        series: [{
          type: "line",
          name: "海拔",
          animation: false,
          markLine: {
            data: [{
              yAxis: 0
            }],
            lineStyle: {
              opacity: 0.8
            },
            label: {
              normal: {
                show: false
              }
            },
            symbol: ['image://https://block-design.oss-cn-shenzhen.aliyuncs.com/project-imgs/xingzhan/%E5%A4%9A%E8%BE%B9%E5%BD%A2%201.png', 'none'],
            symbolSize: [10, 30],
            symbolRotate: -90,
            symbolOffset: ["35%", 0]
          }
        }]
      },
      option2: {
        legend: {},
        tooltip: {},
        grid: {
          left: 0,
          right: 70
        },
        xAxis: {
          show: false
        },
        yAxis: {
          min: 0,
          max: 35,
          name: "高度 m",
          nameLocation: "end",
          boundaryGap: false,
          nameTextStyle: {
            color: "#FFFFFF",
            fontSize: 22,
            fontWeight: "bold",
            padding: [0, 0, 0, 70]
          },
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          splitLine: {
            show: false
          },
          minorTick: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          axisTick: {
            show: true,
            inside: true,
            length: 10,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          axisLabel: {
            inside: true,
            margin: 14,
            fontSize: 22,
            fontWeight: "bold",
            showMinLabel: false,
            showMaxLabel: false,
            formatter: function (value) {
              let str = '';
              // num两种情况，为普通数字（1000以下不带逗号）或千分位数字，全部强转为string类型
              value = value.toString();
              // 将num按逗号分隔
              let arr = value.split(',');
              // for循环将去除逗号的部分拼起来
              for (let i = 0; i < arr.length; i++) {
                str += arr[i];
              }
              return str;
            }
          }
        },
        series: [{
          type: "line",
          name: "高度",
          animation: false,
          markLine: {
            data: [{
              yAxis: 15
            }],
            lineStyle: {
              opacity: 0.8
            },
            label: {
              normal: {
                show: false
              }
            },
            symbol: ['image://https://block-design.oss-cn-shenzhen.aliyuncs.com/project-imgs/xingzhan/%E5%A4%9A%E8%BE%B9%E5%BD%A2%201.png', 'none'],
            symbolOffset: ["35%", 0],
            symbolSize: [10, 30]
          }
        }]
      },
      option3: {
        legend: {
          show: false
        },
        xAxis: {
          show: false
        },
        yAxis: {
          min: -20,
          max: 20,
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: [{
          name: '航向角',
          type: 'gauge',
          min: 0,
          max: 360,
          startAngle: 0,
          endAngle: 360,
          radius: '100%',
          splitNumber: 24,
          clockwise: false,
          animation: false,
          z: 5,
          pointer: {
            show: true,
            icon: 'rect',
            length: "15%",
            width: 2,
            showAbove: true,
            itemStyle: {
              color: "red"
            },
            offsetCenter: [0, "-85%"]
          },
          detail: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: [{
            value: 360 * 3 / 4,
            name: ''
          }],
          axisLabel: {
            show: true,
            rotate: 'tangential',
            distance: -15,
            formatter: function (value) {
              switch (value) {
                case 0:
                  return "N";
                case 15:
                  return "15";
                case 30:
                  return "30";
                case 45:
                  return "NE";
                case 60:
                  return "60";
                case 75:
                  return "75";
                case 90:
                  return "E";
                case 105:
                  return "105";
                case 120:
                  return "120";
                case 135:
                  return "SE";
                case 150:
                  return "150";
                case 165:
                  return "165";
                case 180:
                  return "S";
                case 195:
                  return "195";
                case 210:
                  return "210";
                case 225:
                  return "SW";
                case 240:
                  return "240";
                case 255:
                  return "255";
                case 270:
                  return "W";
                case 285:
                  return "285";
                case 300:
                  return "300";
                case 315:
                  return "NW";
                case 330:
                  return "330";
                case 345:
                  return "345";
                default:
                  break;
              }
            },
            textStyle: {
              fontWeight: 'bold',
              fontSize: 16,
              color: 'black'
            }
          },
          axisLine: {
            lineStyle: {
              color: [[0, '#ffffff'], [1, '#63869e']],
              width: 40
            }
          },
          splitLine: {
            show: false
          }
        }, {
          name: '天空/陆地',
          type: 'pie',
          center: ['50%', '50%'],
          radius: "100%",
          startAngle: 180,
          //角度变化实时加上滚转角度
          animation: false,
          avoidLabelOverlap: false,
          emphasis: {
            disabled: true,
            scale: false,
            focus: 'none'
          },
          label: {
            show: false
          },
          data: [{
            value: 50,
            itemStyle: {
              normal: {
                color: "#0202fe",
                borderWidth: 1,
                borderColor: "#4a8cae",
                opacity: 1
              }
            }
          }, {
            value: 50,
            itemStyle: {
              normal: {
                color: "#028103",
                borderWidth: 1,
                borderColor: "#4a8cae",
                opacity: 1
              }
            }
          }]
        }, {
          type: "line",
          animation: false,
          z: 100,
          markLine: {
            data: [{
              name: '平均线',
              yAxis: -0.6,
              lineStyle: {
                type: 'solid',
                color: 'red',
                width: 3
              }
            }],
            label: {
              normal: {
                show: false
              }
            },
            symbol: ['none', 'none']
          }
        }]
      },
      option4: {
        legend: {
          show: false
        },
        tooltip: {},
        grid: {
          left: 60,
          right: 40
        },
        xAxis: {
          show: false
        },
        yAxis: {
          min: -30,
          max: 30,
          type: 'value',
          splitNumber: 6,
          align: 'right',
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#FFFFFF",
              width: 3
            }
          },
          axisLabel: {
            margin: 14,
            fontSize: 18,
            fontWeight: "bold",
            showMinLabel: false,
            showMaxLabel: false
          }
        },
        series: [{
          type: "line",
          name: '俯仰',
          animation: false,
          markLine: {
            data: [{
              yAxis: 0,
              type: 'average',
              lineStyle: {
                type: 'solid',
                color: '#efc909',
                width: 3
              }
            }],
            label: {
              normal: {
                show: false
              }
            },
            symbol: ['none', 'none'],
            symbolRotate: -90,
            symbolOffset: ["30%", 0]
          }
        }]
      }
    });
    function setFlightData(data) {
      let airspeed = parseInt(data.airspeed);
      if (Math.abs(data.airspeed) < 1) {
        airspeed = 0.5;
      }
      if (state.option.yAxis.max > 10) {
        state.option.yAxis.minorTick.show = true;
        state.option.yAxis.minorTick.splitNumber = 5;
        state.option.yAxis.minorTick.length = 6;
      }
      state.option.series[0].markLine.data[0].yAxis = airspeed;
      if (airspeed < 10) {
        state.option.yAxis.min = airspeed - airspeed;
        state.option.yAxis.max = airspeed + airspeed;
      } else if (10 <= airspeed < 100) {
        state.option.yAxis.min = airspeed - 10;
        state.option.yAxis.max = airspeed + 10;
      } else {
        state.option.yAxis.min = airspeed - 100;
        state.option.yAxis.max = airspeed + 100;
      }
      myChart.setOption(state.option, true);
      let altitude = parseInt(data.altitude);
      if (state.option1.yAxis.max > 100) {
        state.option1.yAxis.minorTick.show = true;
        state.option1.yAxis.minorTick.splitNumber = 5;
        state.option1.yAxis.minorTick.length = 6;
      }
      state.option1.series[0].markLine.data[0].yAxis = altitude;
      if (altitude < 10) {
        state.option1.yAxis.min = altitude - altitude;
        state.option1.yAxis.max = altitude + altitude;
      } else if (10 <= altitude < 100) {
        state.option1.yAxis.min = altitude - 10;
        state.option1.yAxis.max = altitude + 10;
      } else {
        state.option1.yAxis.min = altitude - 100;
        state.option1.yAxis.max = altitude + 100;
      }
      myChart1.setOption(state.option1, true);
      let height = parseInt(data.height);
      if (Math.abs(data.height) < 1) {
        height = 0.5;
      }
      if (state.option2.yAxis.max > 10) {
        state.option2.yAxis.minorTick.show = true;
        state.option2.yAxis.minorTick.splitNumber = 5;
        state.option2.yAxis.minorTick.length = 6;
      }
      state.option2.series[0].markLine.data[0].yAxis = height;
      if (height < 10) {
        state.option2.yAxis.min = height - height;
        state.option2.yAxis.max = height + height;
      } else if (10 <= height < 100) {
        state.option2.yAxis.min = height - 10;
        state.option2.yAxis.max = height + 10;
      } else {
        state.option2.yAxis.min = height - 100;
        state.option2.yAxis.max = height + 100;
      }
      myChart2.setOption(state.option2, true);
      let courseOverGround = parseInt(Math.abs(data.yaw) + 10);
      let startAngle = parseFloat(courseOverGround * 360 / 360) + 90;
      let endAngle = parseFloat(startAngle) + 359.9;
      state.option3.series[0].data[0].value = courseOverGround;
      state.option3.series[0].startAngle = startAngle;
      state.option3.series[0].endAngle = endAngle;
      let roll = parseInt(data.roll);
      let pitch = parseInt(data.pitch);
      state.option3.series[1].startAngle = 180 + roll;
      state.option3.series[1].top = pitch;
      myChart3.setOption(state.option3, true);
      let myChart4Style = document.getElementById('myChart4');
      myChart4Style.style.transform = "rotate(" + -roll + "deg";
      myChart4Style.style.top = pitch + "px";
      state.option4.series[0].markLine.data[0].yAxis = pitch;
      myChart4.setOption(state.option4, true);
      state.currentposition = data.latitude + "," + data.longitude;
      state.currentflighttime = data.flytime !== undefined ? proxy.getTime(data.flytime) : "--";
      state.currentdiatance = data.flydistance;
    }
    const lng = ref(108.956910);
    const lat = ref(34.263710);
    const map = ref({});
    const marker = ref({});
    const T = ref(window.T);
    const flightlines = ref([]);
    const flightHelicopterlines = ref([]);
    const labelMap = ref(new Map());
    const historyLines = ref([]);
    function initMap() {
      nextTick(() => {
        var imageURL = "https://t0.tianditu.gov.cn/img_w/wmts?" + "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" + "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=436ce7e50d27eede2f2929307e6b33c0";
        var lay = new T.value.TileLayer(imageURL, {
          minZoom: 1,
          maxZoom: 18
        });
        var config = {
          layers: [lay]
        };
        //这里T指向天地图对象
        //初始化地图，创建一个新的地图实例
        //其中 `T.Map` 接收的第一个参数是在html中天地图标签的ID
        //第二个参数是天地图的参考系，我这里设置的是 `EPSG:4326`，也就是WGS84 坐标参考系。
        map.value = new T.value.Map("map-containera", config);
        //这一步调用了天地图的setMapType方法，用来设置天地图的图层类型，我这里设置的是卫星图图层
        map.value.setMapType(window.TMAP_HYBRID_MAP);
        //这一步设置的是地图的初始化后的中心点坐标以及缩放级别
        //做完这一步，天地图就以及能在地图上显示出来了
        map.value.centerAndZoom(new T.value.LngLat(lng.value, lat.value), 14);
        map.value.addEventListener("moveend", queryInRect);
        map.value.addEventListener("zoomend", queryInRect);
      });
    }
    function drawRoute(router) {
      setTimeout(function () {
        let defaultLabel = labelMap.value.get("label");
        if (defaultLabel !== undefined) {
          defaultLabel.setZindex(2000000);
          map.value.addOverLay(defaultLabel);
        }
      }, 100);
      lng.value = router[0].lon;
      lat.value = router[0].lat;
      map.value.centerAndZoom(new T.value.LngLat(lng.value, lat.value), 14);
      const routeColor = "#ffea00";
      let beforePoints = [],
        afterPoints = [],
        points = [];
      // 点位处理
      router.forEach((item, index) => {
        const pointTmp = [Number(item.lon), Number(item.lat)];
        points.push(pointTmp);
        index < router.length - 3 ? beforePoints.push(pointTmp) : "";
        index >= router.length - 4 ? afterPoints.push(pointTmp) : "";
      });
      const LEPoint = router[router.length - 5];
      afterPoints.push([Number(LEPoint.lon), Number(LEPoint.lat)]);
      // 航线展示
      const lines = [{
        points: beforePoints,
        style: {
          color: routeColor,
          weight: 2,
          opacity: 1,
          lineStyle: "solid"
        }
      }, {
        points: afterPoints,
        style: {
          color: routeColor,
          weight: 2,
          opacity: 1,
          lineStyle: "dashed"
        }
      }];
      let overLays = [];
      let polygonList = [];
      lines.forEach(item => {
        let polygon = addOnePolyline(item);
        polygonList.push(polygon);
        overLays.push(polygon);
      });
      // 添加点位和圆圈
      points.forEach((item, index) => {
        let content = index - 1;
        let bgColor = routeColor;
        let drawCircle = false;
        switch (index) {
          case 0:
            content = "P1";
            bgColor = "#B6E4A3";
            break;
          case 1:
            content = "O1";
            bgColor = "#B6E4A3";
            drawCircle = true;
            break;
          case points.length - 6:
            content = "O2";
            bgColor = "#D95952";
            drawCircle = true;
            break;
          case points.length - 5:
            content = "E";
            bgColor = "#D95952";
            break;
          case points.length - 4:
            content = "L";
            bgColor = "#D95952";
            break;
          case points.length - 3:
            content = "L1";
            bgColor = "#1BC9CB";
            break;
          case points.length - 2:
            content = "L2";
            bgColor = "#1BC9CB";
            break;
          case points.length - 1:
            content = "L3";
            bgColor = "#1BC9CB";
            break;
        }
        //创建地图文本对象
        overLays.push(addLabel(content, item, bgColor));
        // 画圆
        if (drawCircle) {
          overLays.push(addCircle(points[index], Number(router[index].radius), bgColor));
        }
      });
      // 折线添加中间箭头
      overLays.push(...addArrowToPolylines(polygonList));
      //获得最佳的地图视野
      let bestView = map.value.getViewport(points);
      map.value.centerAndZoom(new T.value.LngLat(bestView.center.lat, bestView.center.lng), bestView.zoom);
      //
      if (historyLines.value.length > 0) {
        console.log("清空历史路线");
        map.value.getOverlays().map(item => {
          historyLines.value.map(tmp => {
            if (tmp.F + "" === item.F + "") {
              map.value.removeOverLay(item);
            }
          });
        });
        historyLines.value = [];
      }
      //添加所有覆盖物
      add_overlay(overLays);
      historyLines.value = overLays;
    }

    //添加覆盖物
    function add_overlay(overLays) {
      overLays.map(item => {
        map.value.addOverLay(item);
      });
    }

    //向地图上添加线
    function addOnePolyline(line) {
      if (!line.points) {
        return;
      }
      let pointList = [];
      const linesTmp = JSON.parse(JSON.stringify(line));
      linesTmp.points.forEach(point => {
        pointList.push(new T.value.LngLat(point[0], point[1]));
      });
      return new T.value.Polyline(pointList, linesTmp.style);
    }

    //创建地图文本对象
    function addLabel(content, item, bgColor) {
      let label = new T.value.Label({
        text: "<div style='background-color: " + bgColor + "; width: 2rem; height: 2rem; font-size: 1rem; border-radius: 50%; border: 0; text-align: center;line-height: 2rem;font-weight: 900'>" + content + "<div>",
        position: new T.value.LngLat(item[0], item[1]),
        offset: new T.value.Point(-32, 6)
      });
      label.setBackgroundColor("transparent");
      label.setBorderLine(0);
      return label;
    }

    //向地图上添加圆
    function addCircle(item, radius, bgColor) {
      return new T.value.Circle(new T.value.LngLat(item[0], item[1]), radius, {
        color: bgColor,
        weight: 1,
        opacity: 0.6,
        fillColor: "#FFFFFF",
        fillOpacity: 0.4,
        lineStyle: "solid"
      });
    }

    // 折线添加中间箭头
    function addArrowToPolylines(polyline) {
      let overLays = [];
      for (let i = 0; i < polyline.length; i++) {
        const points = polyline[i].ht;
        points.forEach((point, index) => {
          // 计算斜度
          const afterPoint = points[index + 1];
          if (!afterPoint) return;
          // 计算中间点位
          const middlePoint = turf.midpoint([point.lng, point.lat], [afterPoint.lng, afterPoint.lat]);
          const bearing = turf.bearing(turf.point([point.lng, point.lat]), turf.point([afterPoint.lng, afterPoint.lat]));
          overLays.push(getcenterpoiont(middlePoint.geometry.coordinates, bearing));
        });
      }
      return overLays;
    }
    function getcenterpoiont(item, bearing) {
      let label = new T.value.Label({
        text: "<img style='transform: rotate(" + bearing + "deg); width: 1.5rem; height: 1.5rem; font-size: 1rem; font-weight: 900;' src='https://block-design.oss-cn-shenzhen.aliyuncs.com/project-imgs/xingzhan/up.svg'>",
        position: new T.value.LngLat(item[0], item[1]),
        offset: new T.value.Point(-30.5, 2.5)
      });
      label.setBackgroundColor("transparent");
      label.setBorderLine(0);
      return label;
    }
    let tmpnum = 0;
    const isFlighting = ref(false);
    function drawHelicopterFlight(satcomData) {
      if (isFlighting.value) {
        if (satcomData.speed < 0.6) {
          zimuDiv.speed = 0;
          return;
        }
      }
      zimu.value = true;
      let item = [satcomData.longitude, satcomData.latitude];
      centerValue.value = item;
      let lastHelicopterlabel = sessionStorage.getItem("lastHelicopterlabel");
      if (satcomData.speed < 0.6) {
        zimuDiv.speed = 0;
      } else {
        zimuDiv.speed = satcomData.speed;
      }
      zimuDiv.uid = satcomData.uid;
      zimuDiv.longitude = satcomData.longitude;
      zimuDiv.latitude = satcomData.latitude;
      zimuDiv.height = satcomData.height;
      zimuDiv.headingAngle = satcomData.headingAngle;
      if (lastHelicopterlabel !== null) {
        let tmpLable = undefined;
        map.value.getOverlays().map(item => {
          if (lastHelicopterlabel === item.F + "") {
            tmpLable = item;
          }
        });
        if (tmpLable === undefined) {
          tmpLable = labelMap.value.get("label");
          tmpLable.setZindex(2000000);
          tmpLable.setLngLat(new T.value.LngLat(item[0], item[1]));
          map.value.addOverLay(tmpLable);
          labelMap.value.set("label", tmpLable);
        } else {
          tmpLable.setZindex(2000000);
          tmpLable.setLngLat(new T.value.LngLat(item[0], item[1]));
          labelMap.value.set("label", tmpLable);
        }
      } else {
        let defaultLabel = labelMap.value.get("label");
        if (defaultLabel !== undefined) {
          map.value.removeOverLay(defaultLabel);
        }
        let label = new T.value.Label({
          text: "<img class='airsvg-card' style='width: 3.2rem; height: 3.2rem;' src='/icon/helicopter.png'>",
          position: new T.value.LngLat(item[0], item[1]),
          offset: new T.value.Point(-32, 0)
        });
        label.setBackgroundColor("transparent");
        label.setBorderLine(0);
        map.value.addOverLay(label);
        sessionStorage.setItem("lastHelicopterlabel", label.F);
        labelMap.value.set("label", label);
      }
      let lastFlightData = JSON.parse(sessionStorage.getItem("lastHelicopterFlightData"));
      if (lastFlightData === null) {
        sessionStorage.setItem("lastHelicopterFlightData", JSON.stringify(satcomData));
        map.value.centerAndZoom(new T.value.LngLat(item[0], item[1]), 14);
        isFlighting.value = true;
      } else {
        let beforeitem = [lastFlightData.longitude, lastFlightData.latitude];
        if (item[0] !== beforeitem[0] && item[1] !== beforeitem[1]) {
          const mapmincard = document.querySelector(".airsvg-card");
          mapmincard.style.transform = "rotate(" + getBearing(item, beforeitem) + "deg)";
          sessionStorage.setItem("lastHelicopterFlightData", JSON.stringify(satcomData));
          let flightline = drawline(item, beforeitem);
          map.value.addOverLay(flightline);
          flightHelicopterlines.value.push(flightline);
          tmpnum = 0;
        } else {
          tmpnum++;
          if (tmpnum > 100) {
            //相同点位置触发重画
            flighting.value = true;
          }
        }
      }
    }
    watch(() => flightHelicopterlines.value.length, (newVal, oldVal) => {
      if (flighting.value) {
        for (let i = 0; i < flightHelicopterlines.value.length - 1; i++) {
          map.value.getOverlays().map(item => {
            if (flightHelicopterlines.value[i].F + "" === item.F + "") {
              map.value.removeOverLay(item);
            }
          });
        }
        intervarTime.value = new Date().getTime() + 1000 * 60 * 10;
        console.log("重新设置轨迹保留时间： ", intervarTime.value);
        flighting.value = false;
        clearInterval(timer);
      }
      if (intervarTime.value !== undefined) {
        if (intervarTime.value <= new Date().getTime()) {
          //保留半小时内的轨迹，大于半小时每两分钟清除一段
          timer = setInterval(function () {
            if (flightHelicopterlines.value.length > 300) {
              for (let i = 0; i < 118; i++) {
                map.value.getOverlays().map(item => {
                  if (flightHelicopterlines.value[i].F + "" === item.F + "") {
                    map.value.removeOverLay(item);
                  }
                });
              }
              flightHelicopterlines.value.splice(0, 118);
            }
          }, 120000);
          intervarTime.value = undefined;
        }
      }
    });
    const centerIntervarTime = ref(undefined);
    const centerFlag = ref(true);
    const centerValue = ref(undefined);
    watch(() => centerValue.value, (newVal, oldVal) => {
      if (centerFlag.value) {
        centerIntervarTime.value = new Date().getTime() + 1000 * 60 * 1;
        centerFlag.value = false;
      }
      if (centerIntervarTime.value <= new Date().getTime()) {
        //保留半小时内的轨迹，大于半小时每两分钟清除一段
        map.value.centerAndZoom(new T.value.LngLat(newVal[0], newVal[1]), 14);
        centerFlag.value = true;
        centerIntervarTime.value = undefined;
      }
    });
    function drawFlight(flightData) {
      //console.log(flightData)
      setRealMessage(flightData);
      let item = [flightData.longitude, flightData.latitude];
      centerValue.value = item;
      let lastlabel = sessionStorage.getItem("lastlabel");
      if (lastlabel !== null) {
        let tmpLable = undefined;
        map.value.getOverlays().map(item => {
          if (lastlabel === item.F + "") {
            tmpLable = item;
          }
        });
        if (tmpLable === undefined) {
          tmpLable = labelMap.value.get("label");
          tmpLable.setZindex(2000000);
          tmpLable.setLngLat(new T.value.LngLat(item[0], item[1]));
          map.value.addOverLay(tmpLable);
          labelMap.value.set("label", tmpLable);
        } else {
          tmpLable.setZindex(2000000);
          tmpLable.setLngLat(new T.value.LngLat(item[0], item[1]));
          labelMap.value.set("label", tmpLable);
        }
      } else {
        let defaultLabel = labelMap.value.get("label");
        if (defaultLabel !== undefined) {
          map.value.removeOverLay(defaultLabel);
        }
        let label = new T.value.Label({
          text: "<img class='airsvg-card' style='width: 2.2rem; height: 2.2rem;' src='/icon/air.svg'>",
          position: new T.value.LngLat(item[0], item[1]),
          offset: new T.value.Point(-32, 0)
        });
        label.setBackgroundColor("transparent");
        label.setBorderLine(0);
        map.value.addOverLay(label);
        sessionStorage.setItem("lastlabel", label.F);
        labelMap.value.set("label", label);
      }
      let lastFlightData = JSON.parse(sessionStorage.getItem("lastFlightData"));
      if (lastFlightData === null) {
        sessionStorage.setItem("lastFlightData", JSON.stringify(flightData));
      } else {
        const mapmincard = document.querySelector(".airsvg-card");
        mapmincard.style.transform = "rotate(" + flightData.yaw + "deg)";
        let beforeitem = [lastFlightData.longitude, lastFlightData.latitude];
        if (item[0] !== beforeitem[0] && item[1] !== beforeitem[1]) {
          sessionStorage.setItem("lastFlightData", JSON.stringify(flightData));
          let flightline = drawline(item, beforeitem);
          map.value.addOverLay(flightline);
          flightlines.value.push(flightline);
          tmpnum = 0;
        } else {
          tmpnum++;
          if (tmpnum > 10) {
            flighting.value = true;
          }
        }
      }
    }
    const intervarTime = ref(undefined);
    const flighting = ref(true);
    let timer;
    watch(() => flightlines.value.length, (newVal, oldVal) => {
      if (flighting.value) {
        for (let i = 0; i < flightlines.value.length - 1; i++) {
          map.value.getOverlays().map(item => {
            if (flightlines.value[i].F + "" === item.F + "") {
              map.value.removeOverLay(item);
            }
          });
        }
        flightlines.value = [];
        intervarTime.value = new Date().getTime() + 1000 * 60 * 10;
        console.log("重新设置轨迹保留时间： ", intervarTime.value, new Date());
        flighting.value = false;
        clearInterval(timer);
      }
      if (intervarTime.value !== undefined) {
        if (intervarTime.value <= new Date().getTime()) {
          //保留10分钟内的轨迹，大于10分钟每一分钟清除一段（118个点）
          console.log("轨迹保留时间到了", new Date());
          timer = setInterval(function () {
            if (flightlines.value.length > 300) {
              for (let i = 0; i < 118; i++) {
                map.value.getOverlays().map(item => {
                  if (flightlines.value[i].F + "" === item.F + "") {
                    map.value.removeOverLay(item);
                  }
                });
              }
              console.log("删除尾巴", new Date());
              console.log("删除前的长度", flightlines.value.length);
              flightlines.value.splice(0, 118);
              console.log("删除后的长度", flightlines.value.length);
            }
          }, 60000);
          intervarTime.value = undefined;
        }
      }
    });

    // 计算斜率
    function getBearing(point, beforePoint) {
      let bearing = turf.bearing(turf.point(point), turf.point(beforePoint));
      return bearing + 180;
    }
    function drawline(item, beforeitem) {
      let pointList = [];
      pointList.push(new T.value.LngLat(beforeitem[0], beforeitem[1]));
      pointList.push(new T.value.LngLat(item[0], item[1]));
      return new T.value.Polyline(pointList, {
        color: "#04f3f7",
        weight: 2,
        opacity: 1,
        lineStyle: "solid"
      });
    }
    function queryInRect(event) {
      let overLays = map.value.getOverlays();
      map.value.clearOverLays();
      add_overlay(overLays);
    }
    function drawAir(deviceInfo) {
      if (deviceInfo.longitude === null || deviceInfo.latitude === null || deviceInfo.longitude === undefined || deviceInfo.latitude === undefined || deviceInfo.longitude === '' || deviceInfo.latitude === '') {
        return;
      }
      let content = "";
      if (deviceInfo.deviceType === '0') {
        content = "<img class='airsvg-card' style='width: 2.2rem; height: 2.2rem;' src='/icon/air.svg'>";
      } else if (deviceInfo.deviceType === '3') {
        content = "<img class='airsvg-card' style='width: 3.2rem; height: 3.2rem;' src='/icon/helicopter.png'>";
      } else if (deviceInfo.deviceType === '4') {
        content = "<img class='taskCar' style='width: 3.2rem; height: 3.2rem;' src='/icon/task_car.png'>";
      } else {
        content = "<img class='airsvg-card' style='width: 4.8rem; height: 4.8rem;' :src='" + pageData.icon + "'>";
      }
      let item = [deviceInfo.longitude, deviceInfo.latitude];
      let label = new T.value.Label({
        text: content,
        position: new T.value.LngLat(item[0], item[1]),
        offset: new T.value.Point(-36, 0)
      });
      label.setBackgroundColor("transparent");
      label.setBorderLine(0);
      let defaultLabel = labelMap.value.get("label");
      if (defaultLabel !== undefined) {
        map.value.removeOverLay(defaultLabel);
      }
      map.value.addOverLay(label);
      if (deviceInfo.deviceType === '4') {
        labelMap.value.set("carLabel", label);
      } else {
        map.value.centerAndZoom(new T.value.LngLat(item[0], item[1]), 14);
        labelMap.value.set("label", label);
      }
    }
    function clearFlightLines() {
      sessionStorage.clear();
      if (flightlines.value.length > 0) {
        for (let i = 0; i < flightlines.value.length; i++) {
          map.value.getOverlays().map(item => {
            if (flightlines.value[i].F + "" === item.F + "") {
              map.value.removeOverLay(item);
            }
          });
        }
        flightlines.value = [];
      }
    }
    function initECharts() {
      if (props.showSubtitle) {
        myChart.setOption(state.option);
        myChart1.setOption(state.option1);
        myChart2.setOption(state.option2);
        myChart3.setOption(state.option3);
        myChart4.setOption(state.option4);
        state.currentposition = "--，-- ";
        state.currentflighttime = "--";
        state.currentdiatance = "--";
      }
    }
    function clearOverLays() {
      map.value.clearOverLays();
    }
    function updateviewer(inClass) {
      const mapmincard = document.querySelector(".mapmincard");
      mapmincard.style.display = "flex";
      if (inClass === "minTalking" || inClass === "maxTalking") {
        mapmincard.style.background = "unset";
        mapmincard.style.top = "unset";
        mapmincard.style.padding = "unset";
      } else if (inClass === "notShowMin") {
        if (pageData.taskPlay === "maxTalking") {
          mapmincard.style.display = "none";
        }
      }
      setTimeout(function () {
        map.value.checkResize();
      }, 100);
    }
    onMounted(() => {
      initMap();
      if (props.showSubtitle) {
        initeCharts();
      }
      setTimeout(function () {
        for (let dev of pageData.childDeviceList) {
          if (dev.deviceType === '4') {
            drawAir(dev);
          }
        }
        drawAir(pageData.deviceInfo);
        if (permissionStore.flyRouter !== undefined) {
          if (permissionStore.flyRouter.waypoints !== undefined) {
            drawRoute(permissionStore.flyRouter.waypoints);
          }
        }
      }, 500);
    });
    onUnmounted(() => {
      clearOverLays();
      historyLines.value = [];
      clearInterval(timer);
    });
    __expose({
      drawRoute,
      drawHelicopterFlight,
      drawFlight,
      setFlightData,
      clearFlightLines,
      initECharts,
      clearOverLays,
      updateviewer
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(VideoCard, {
        ref: "mapVideoCardRef",
        "show-subtitle": props.showSubtitle,
        "controlel-size": _unref(controlelSize),
        "show-video-camera": false,
        "video-div-is": false,
        "show-switch": props.showSwitch,
        "show-picture-outlined": false,
        onSwitchChange: onMapVideoCardSwitchChange,
        onSwitchChangezhishengji: onMapSwitchChange,
        onFullScreenClick: onMapVideoCardFullScreenClick,
        onUpdateView: onMapVideoCardUpdateView,
        class: "mapmincard"
      }, {
        default: _withCtx(() => [__props.spilt !== 3 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(TextCard, {
          ref: "mapVideoTextRef",
          text: "任务地图",
          "font-size": "1.6rem",
          color: "#FFFFFF",
          padding: "0"
        }, null, 512)])) : _createCommentVNode("", true), __props.spilt === 3 && _unref(pageData).viewerClass === 'maxTalking' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(TextCard, {
          ref: "mapVideoTextRef",
          text: __props.oneName,
          "font-size": "2rem",
          color: "#FFFFFF",
          padding: "0"
        }, null, 8, ["text"])])) : _createCommentVNode("", true), _unref(zimu) && _unref(zimuSwitch) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("table", null, [_createElementVNode("tr", null, [_cache[1] || (_cache[1] = _createElementVNode("td", null, "飞机编号:", -1)), _createElementVNode("td", null, _toDisplayString(_unref(pageData).manMachineNumber ? _unref(pageData).manMachineNumber : _unref(pageData).deviceInfo.name), 1)]), _createElementVNode("tr", null, [_cache[2] || (_cache[2] = _createElementVNode("td", null, "经度:", -1)), _createElementVNode("td", null, _toDisplayString(_unref(zimuDiv).longitude), 1)]), _createElementVNode("tr", null, [_cache[3] || (_cache[3] = _createElementVNode("td", null, "纬度:", -1)), _createElementVNode("td", null, _toDisplayString(_unref(zimuDiv).latitude), 1)]), _createElementVNode("tr", null, [_cache[4] || (_cache[4] = _createElementVNode("td", null, "高度(海拔):", -1)), _createElementVNode("td", null, _toDisplayString(_unref(zimuDiv).height) + "m", 1)]), _createElementVNode("tr", null, [_cache[5] || (_cache[5] = _createElementVNode("td", null, "航向:", -1)), _createElementVNode("td", null, _toDisplayString(_unref(zimuDiv).headingAngle) + "°", 1)]), _createElementVNode("tr", null, [_cache[6] || (_cache[6] = _createElementVNode("td", null, "地速:", -1)), _createElementVNode("td", null, _toDisplayString(_unref(zimuDiv).speed) + "m/s", 1)])])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_4, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "map-containera",
          id: "map-containera"
        }, null, -1)), props.showSubtitle ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "routerChatBg",
          ref_key: "chatbox",
          ref: chatbox,
          onMousedown: _cache[0] || (_cache[0] = $event => dragx($event))
        }, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "routerChat"
        }, [_createElementVNode("div", {
          id: "myChart",
          style: {
            "width": "100px",
            "height": "450px",
            "display": "inline-block"
          }
        }), _createElementVNode("div", {
          style: {
            "width": "440px",
            "height": "450px",
            "display": "inline-block",
            "position": "relative"
          }
        }, [_createElementVNode("div", {
          id: "myChart3",
          style: {
            "width": "440px",
            "height": "450px"
          }
        }), _createElementVNode("div", {
          id: "myChart4",
          style: {
            "width": "260px",
            "height": "360px",
            "margin-top": "-400px",
            "margin-left": "90px"
          }
        })]), _createElementVNode("div", {
          id: "myChart1",
          style: {
            "width": "80px",
            "height": "450px",
            "display": "inline-block"
          }
        }), _createElementVNode("div", {
          id: "myChart2",
          style: {
            "width": "70px",
            "height": "450px",
            "display": "inline-block"
          }
        })], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, " 位置: " + _toDisplayString(_unref(state).currentposition), 1), _createElementVNode("div", null, " 本架次飞行时间: " + _toDisplayString(_unref(state).currentflighttime), 1), _createElementVNode("div", null, " 本架次飞行距离: " + _toDisplayString(_unref(state).currentdiatance) + " (m)", 1)])], 544)) : _createCommentVNode("", true)], 512), [[_vShow, _unref(pageData).viewerShow]])]),
        _: 1
      }, 8, ["show-subtitle", "controlel-size", "show-switch"]);
    };
  }
};